export default {
    token: state => {                
        var credentials = JSON.parse(state.credentials);        
        return credentials ? credentials.accessToken : null;
    },
    claims: state => {
        var credentials = JSON.parse(state.credentials);        
        return credentials && credentials.userToken ? credentials.userToken.claims : []
    }
}